import { render, staticRenderFns } from "./ProfessionalRating.vue?vue&type=template&id=2eb60d7e&"
import script from "./ProfessionalRating.vue?vue&type=script&lang=js&"
export * from "./ProfessionalRating.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports